export const MAX_DATA_APP_ACTION_LENGTH = 128

export function buildMicroAppRpcBody(
  property: string,
  args: unknown[],
): { action: string; input: unknown } | { method: string; args: unknown[] } {
  if (property !== 'call') return { method: property, args }
  const action = args[0]
  if (
    typeof action !== 'string' ||
    !action ||
    action.length > MAX_DATA_APP_ACTION_LENGTH ||
    !/^[a-zA-Z0-9][a-zA-Z0-9._:-]*$/.test(action)
  ) {
    throw new Error('ros.call action is invalid')
  }
  return { action, input: args.length > 1 ? args[1] : null }
}

export function microAppAssetApiPath(
  definitionId: string,
  assetPath: unknown,
  artifactVersion?: number,
): string {
  if (typeof assetPath !== 'string' || !assetPath) {
    throw new Error('ros.assetUrl path is required')
  }
  const parts = assetPath.split('/')
  if (
    assetPath.length > 1024 ||
    assetPath.startsWith('/') ||
    assetPath.includes('\\') ||
    parts.some((part) => !part || part === '.' || part === '..')
  ) {
    throw new Error('ros.assetUrl path is invalid')
  }
  const query = artifactVersion ? `?artifactVersion=${artifactVersion}` : ''
  return `/api/micro-apps/${encodeURIComponent(definitionId)}/assets/${parts.map(encodeURIComponent).join('/')}${query}`
}

/** Cap'n Web serializes typed byte arrays, but rejects a raw ArrayBuffer. */
export async function readMicroAppAssetResponse(
  response: Response,
): Promise<{ bytes: Uint8Array; contentType: string }> {
  return {
    bytes: new Uint8Array(await response.arrayBuffer()),
    contentType: response.headers.get('Content-Type') || 'application/octet-stream',
  }
}

/** Turn sandbox bootstrap failures into a safe, visible host-panel error. */
export function microAppRuntimeErrorMessage(data: unknown): string | null {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null
  const candidate = data as { type?: unknown; level?: unknown; message?: unknown }
  if (candidate.type !== 'console' || candidate.level !== 'error' || !Array.isArray(candidate.message)) {
    return null
  }
  const message = candidate.message
    .filter((part): part is string => typeof part === 'string')
    .join(' ')
    .trim()
  return message ? message.slice(0, 2_000) : 'The App Artifact could not start.'
}
